const API_BASE = '/api/v1/sky';
const CACHE_KEY = 'nowtarot_sky_today';
const CACHE_MS = 10 * 60 * 1000;

export function localTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

async function errorMessage(response) {
  try {
    const body = await response.json();
    if (typeof body.detail === 'string' && body.detail) return body.detail;
  } catch {
    // The body was not JSON.
  }
  return 'Something went wrong. Please try again.';
}

function cached(tz) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
    if (saved && saved.tz === tz && Date.now() - saved.at < CACHE_MS) return saved.data;
  } catch {
    // private mode
  }
  return null;
}

let inflight = null;

export async function getSkyToday() {
  if (typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap') {
    throw new Error('The sky is not baked into prerendered pages.');
  }
  const tz = localTimezone();
  const saved = cached(tz);
  if (saved) return saved;
  if (!inflight) {
    inflight = fetch(`${API_BASE}/today?tz=${encodeURIComponent(tz)}`)
      .then(async (response) => {
        if (!response.ok) throw new Error(await errorMessage(response));
        const data = await response.json();
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify({ tz, at: Date.now(), data }));
        } catch {
          // private mode
        }
        return data;
      })
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

export async function getPhaseOn(date) {
  const tz = localTimezone();
  const response = await fetch(`${API_BASE}/phase?date=${encodeURIComponent(date)}&tz=${encodeURIComponent(tz)}`);
  if (!response.ok) throw new Error(await errorMessage(response));
  return response.json();
}
